/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import styled from "styled-components";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  Dialog,
  Slide,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useRecoilValue } from "recoil";
import { configState, loginState } from "../lib/Store";
import { useHistory } from "react-router-dom";
import RegisterMain from "./RegisterMain";
import RegisterConfirm from "./RegisterConfirm";
import RegisterForm from "./RegisterForm";
import RegisterDone from "./RegisterDone";
import Loading from "./Loading";
import pr from "../lib/pr";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Login() {  
  const login = useRecoilValue(loginState);
  const config = useRecoilValue(configState);
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [loaded, setLoaded] = useState(false);

  const onJoin = () => {
    openRes();
  };

  const openRes = () => {
    setOpen(true);
  };

  const closeRes = () => {
    setOpen(false);
    setPage(1);
  };

  const goNextPage = () => {
    setPage(page + 1);
  };

  const goPreviousPage = () => {
    setPage(page - 1);
  };

  // ID/PASS
  const [data, setData] = useState({ user_id: "", user_pass: "" });
  const onChangeData = (e) => {
    setData((state) => ({ ...state, [e.target.id]: e.target.value }));
  };

  // 로그인
  const onFormSubmit = async (e) => {
    e.preventDefault();
    let result = await axios.post(config.api+"/hr/login", { ...data, cid: config.cid });
    if (result.data.success === 1) {
      localStorage.setItem("token", result.data.token);
      window.location.href='/home'      
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };
  
  return (
    <>
      <Dialog
        fullScreen
        open={open}
        TransitionComponent={Transition}
        onClose={closeRes}
      >
        <Grid
          className="header"
          container
          direction="row"
          justifyContent="space-between"
          width="100%"
          style={{
            padding: "5px",
            fontSize: "20px",
            background: "#0092a2",
            color: "white",
          }}
        >
          회원가입
          <ClearIcon onClick={closeRes}></ClearIcon>
        </Grid>

        {page === 1 ? (
          <RegisterMain
            goNextPage={goNextPage}
            goPreviousPage={goPreviousPage}
          ></RegisterMain>
        ) : null}
        {page === 2 ? (
          <RegisterConfirm
            goNextPage={goNextPage}
            goPreviousPage={goPreviousPage}
          ></RegisterConfirm>
        ) : null}
        {page === 3 ? (
          <RegisterForm
            goNextPage={goNextPage}
            goPreviousPage={goPreviousPage}
          ></RegisterForm>
        ) : null}
        {page === 4 ? (
          <RegisterDone
            closeRes={closeRes}
            goNextPage={goNextPage}
            goPreviousPage={goPreviousPage}
          ></RegisterDone>
        ) : null}
      </Dialog>

      {!setLoaded ? (
        <Loading></Loading>
      ) : (
        <Grid
          container
          height="100vh"
          direction="column"
          css={css`
            .swal2-container {
              z-index: 20000 !important;
            }
          `}
        >
          <Grid
            container
            flex="1"
            direction="column"
            justifyContent="space-around"
            css={css`
              max-width: 350px;
              margin: 0 auto;
            `}
          >
            <Grid
              className="logo"
              style={{
                textAlign: "center",
              }}
            >
              <img
                className="logoimg"
                src="/img/logo.png"
                css={css`
                  width: 80%;
                  max-width: 200px;
                `}
              />
              <div
                className="bold"
                css={css`
                  font-size: 16px;
                `}
              >
                두써킷 Heart Rate
              </div>
            </Grid>

            <Box
              component="form"
              container
              width="100%"
              justifyContent="center"
              css={css`
                text-align: center;
              `}
              onSubmit={onFormSubmit}
            >
              <Box
                css={css`
                  margin-bottom: 10px;
                  font-weight: bold;
                  font-size: 18px;
                `}
              >
                관리자 로그인
              </Box>
              <TextField
                id="user_id"
                onChange={onChangeData}
                size="small"
                label="연락처"
                style={{
                  width: "95%",
                  marginBottom: "10px",
                }}
                autoComplete="off"
              ></TextField>
              <TextField
                type="password"
                id="user_pass"
                onChange={onChangeData}
                size="small"
                label="비밀번호"
                style={{
                  width: "95%",
                  marginBottom: "10px",
                }}
                autoComplete="off"
              ></TextField>
              <Box
                style={{
                  marginBottom: "10px",
                }}
              ></Box>
              <Button
                type="submit"
                variant="contained"
                style={{
                  width: "95%",
                  background: "#0092a2",
                }}
              >
                로그인
              </Button>
              <Box
                css={css`
                  margin-top: 10px;
                `}
              >
                {/* <Link>비밀번호 찾기</Link> */}
              </Box>

              {/* <Box
                css={css`
                  margin-top: 30px;
                `}
              >
                계정이 없다면 &nbsp;<Link onClick={onJoin}>회원가입</Link>을
                클릭하세요.
              </Box> */}
            </Box>

            <Box>&nbsp;</Box>
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default Login;
